import type React from 'react';

import { RepeatIcon, SettingsIcon } from '@vlabs/icons';
import { ButtonScrimGroup, Control } from '@vlabs/uikit';
import i18n from 'i18next';
import qs from 'qs';
import { useLocation } from 'react-router-dom';

import st from './VideoControl.module.sass';
import { useVideoCheckForm } from '../video-check-form';

const cloneFileList = (fileList: FileList | undefined) => {
  if (fileList === undefined) return undefined;
  const dataTransfer = new DataTransfer();
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < fileList.length; i++) {
    const clonedFile = new File([fileList[i]], fileList[i]?.name, {
      type: fileList[i]?.type,
      lastModified: fileList[i]?.lastModified,
    });
    dataTransfer.items.add(clonedFile);
  }
  return dataTransfer.files;
};

{ /* FIXME: временное решение */ }

const normalizeRate = (rawRate) => ({
  ...rawRate,
  unit: {
    value: rawRate.unit,
    label: i18n.t(`lunaApi:константы.video analytics.sending type.${rawRate.unit}`),
  },
});

{ /* FIXME: сделать нормальную передачу пропсов */ }
function VideoControl({
  taskData,
}: any): React.JSX.Element {
  const file = taskData.fileList?.[0];
  const { search } = useLocation();
  const parsed = qs.parse(search, {
    ignoreQueryPrefix: true,
  });
  { /* FIXME: временное решение */ }
  const checks = {
    deepfake: parsed.deepfake === 'true',
    liveness: parsed.liveness === 'true',
    face: parsed.face === 'true',
    body: parsed.body === 'true',
  };

  const newImageCheckForm = useVideoCheckForm({
    parameters: {
      ...taskData.parameters,
      rate: normalizeRate(taskData.parameters?.rate),
    },
    ...checks,
    fileList: undefined,
  });
  const existedImageCheckForm = useVideoCheckForm({
    parameters: {
      ...taskData.parameters,
      rate: normalizeRate(taskData.parameters?.rate),
    },
    ...checks,
    fileList: cloneFileList(taskData.fileList),
  });
  if (!file) return null;

  return (
    <div className={st.Controls}>
      {newImageCheckForm.wrap(({ onClick }) => (
        <ButtonScrimGroup>
          <Control.IconButton
            icon={<RepeatIcon />}
            kind="secondary"
            onClick={onClick}
            variant="flat"
          />
        </ButtonScrimGroup>
      ))}
      {existedImageCheckForm.wrap(({ onClick }) => (
        <ButtonScrimGroup>
          <Control.IconButton
            icon={<SettingsIcon />}
            kind="secondary"
            onClick={onClick}
            variant="flat"
          />
        </ButtonScrimGroup>
      ))}
    </div>
  );
}

export { VideoControl };
